import { Scene } from '../types/game';

export const scenes: Scene[] = [
  {
    id: 'intro',
    title: '故事背景',
    content: `公元2100年，人类已经可以通过"虫洞引擎"到达遥远的星球。你作为"大航海号"飞船的船长，偶然间在宇宙中发现了一个充满绿色与神秘的星球——森木。

这是一个被森林覆盖的星球，地面布满像藤蔓一样会动的植物，空中飘着像水母一样缓缓飞行的叶子。夜晚，有的水会发出蓝色的光，像地面上的星星。这里没有建筑，也没有道路，但一切却奇妙地协调运行着，像是整个星球都有自己的意识。

你穿过藤蔓缠绕的森林，脚下的土地微微发光，空中漂浮着会飞的种子和透明叶子。星球仿佛在用某种方式，感知你的到来。
`,
    image: '/images/context.png'
  },
  {
    id: 'scene1',
    title: '意识之门',
    content: `你踏出"光启号"，脚下的青苔自动避让，一条温润的小径在你的每一步下徐徐伸展。

沿着这条藤根小径，你穿越了漂浮植物织就的拱门，感受到地表微微跳动的能量脉搏。林间雾气像有意识地为你让路，一些会发光的种子轻盈地在你身边旋转飞舞，仿佛在观望，也仿佛在欢迎。

你走过一段覆盖着苔藓的高台，经过几株半透明的植物，它们会发出像水滴一样的低鸣，每鸣一次，地面便有一道光痕延伸出去。

最终，你来到一片空地，眼前是一棵比一切都更庞大的巨树，主干宛如山峦般蜿蜒而上，粗糙而温柔地延伸进云雾之中。

就在你靠近树干时，一股温柔的意识突然涌入脑海，不是语言，而像梦境中缓慢展开的声音：

"你来自远方，我们欢迎你。"`,
    image: '/images/part1_s1.png',
    choices: {
      A: {
        text: '你试图回应这股意识，传递出你的问候与善意。',
        score: 'E',
        feedback: '你主动释放出平静而友善的意念，回应了对方的欢迎。刹那间，周围的藤根像共振般泛起一道温和的蓝光，一圈圈地扩散开来，仿佛整棵森林都在回应你的问候。那股意识传来一种轻快的情绪，像微笑般拂过你的心头。你感受到了一种真实的接纳——你已被这片土地认定为"朋友"。'
      },
      B: {
        text: '你保持静默，谨慎地观察这股意识的节奏与内容。',
        score: 'I',
        feedback: '意识频率放缓，光流微微收束，像在耐心等待。它再次温柔地靠近你，继续向你发出善意的邀请。'
      }
    }
  },
  {
    id: 'scene2',
    title: '森灵之家',
    content: `你踏入森灵的栖居之地，一株株巨树的树心被自然雕空，内部却温暖柔和，像是生长出来的居所。地面铺满发光苔藓，像被星光浸润。

你看到：
• 🌿 一位森灵将晶藤缠绕在半空，一边吹奏，一边用尾指控制光频变化，像是在弹一首"森林之歌"
• 🌱 几位幼年森灵围坐在圆形的孢子云上，用意念投影影像，讲述一个会变颜色的故事
• 💧 一位年长者正往能量池中滴入一滴蓝光水，随后席地冥想，那片水波随呼吸节奏扩散
• 🐚 居所间没有门，只有活着的"膜"，森灵靠近时自然开启，无需触碰也无需言语`,
    image: '/images/part1_s2.png',
    choices: {
      A: {
        text: '你认真观察每个细节，试图理解每种行为背后的逻辑与功能。',
        score: 'S',
        feedback: '你发现孢子影像反应机制，孩子们围上来与光叶互动，你获得"互动叶片"。'
      },
      B: {
        text: '你沉浸在这片氛围中，感受他们生活背后的精神秩序。',
        score: 'N',
        feedback: '你与整座树屋共振，一位森灵给你画下"心印符号"，象征精神接纳。'
      }
    }
  },
  {
    id: 'scene3',
    title: '光语仪式',
    content: `夜色降临，你被邀请来到"共振厅"——由巨大浮叶围成的空中圆场。中央是一块发光的共鸣石，石面刻着自然纹路，发出规律的蓝光。

每位森灵盘坐在光席上，头顶松果体发出细微频率，与共鸣石同步呼吸。他们在进行一种古老的"光语仪式"，通过频率共振传达意识。

你被引导参与仪式，面前悬浮着一颗"共鸣种子"。`,
    image: '/images/part1_s3.png',
    choices: {
      A: {
        text: '你分析光频与环境之间的关系，推测它们的结构与传导机制。',
        score: 'T',
        feedback: '你成功识别"非语言逻辑结构"，共鸣石亮起，你获得"频率映射图"。'
      },
      B: {
        text: '你闭上眼，融入频率与情绪，让自己成为仪式的一部分。',
        score: 'F',
        feedback: '你与情绪共鸣，脑中浮现你记忆中的家，圣泉回应你，你获得"情绪回声"。'
      }
    }
  },
  {
    id: 'scene4',
    title: '圣泉初现',
    content: `清晨，森灵带你走进一处森林核心的天然空谷。这里地势渐高，树木安静地退让，仿佛都在守护一件神圣之物。

你抬头望见：一块高起的天然石台浮现在雾光中，台面如柔和的螺旋，表面爬满发光藤蔓。

台中心，是圣泉。

泉水从泉眼中缓慢升起，形成半悬浮的绿色能量液滴，每一滴停在空中数秒后落入泉中，激起金绿色的涟漪，宛如星辰呼吸。

森灵围绕圣泉石台层层盘坐，仰头静默，面容庄重。

你被允许站在外圈，见证这一刻。

你悄悄启用飞船携带的高频能量扫描仪，轻轻指向那片泛着微光的泉水。一串数据悄然浮现在你的护目镜上：

能量密度：飞船标准燃料的 4160 倍。 1滴能够让一架5层楼高的宇宙飞船在宇宙中航行一个月。

你屏住呼吸。

如果这是真实且可控的，这可能会彻底改变地球的能源格局。

但周围的森灵仍在虔诚地注视着圣泉，丝毫不知你刚刚做了什么。

就在仪式结束时，一颗特别的晶核漂浮到你面前，发出温和蓝白光。森灵没有说话，只是看着你，仿佛在等你回应。

你伸手接过，第一次意识到——

从此刻起，你的选择，将影响这个世界。`,
    image: '/images/part1_s4.png'
  }
]; 